import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import FFSiderBox from './ffSiderBox';
import NewsSiderTabs from '../../../components/newsSiderTabs';

class FFNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ffNewsSiderContent, ffNewsSiderTabs },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                <div id="ffhSiderList" className={styles.sider}>
                    <Chip
                        id="50097"
                        type="struct"
                        title="互娱讲堂"
                        groupName="大风号要闻区左侧栏"
                        content={ffNewsSiderContent}>
                        <FFSiderBox />
                    </Chip>
                </div>
                <Chip
                    id="50100"
                    type="struct"
                    title="音乐标签"
                    groupName="大风号要闻区左侧栏"
                    content={ffNewsSiderTabs}>
                    <NewsSiderTabs />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FFNewsSider);
